export const getUser = state => state.user;
export const getUserLoading = state => getUser(state).loading;
export const getUserAuthenticated = state => getUser(state).authenticated;
export const getUserPremium = state => getUser(state).premium;
export const getPlayers = state => getUser(state).players;
export const getPlayerName = state => getUser(state).activePlayer;
export const getPlayer = state => getPlayers(state)[getPlayerName(state)];
export const getPlayerPrizes = state => getPlayer(state).prizes;
export const getPlayerPrizeIds = state => getPlayer(state).prizeIds;
export const getPlayerPrizeById = (state, id) => getPlayerPrizes(state)[id];
export const getPlayerPirate = state => getPlayer(state).pirate;



// WEBPACK FOOTER //
// ./src/reducers/user/selectors.js